export const FONT_FAMILY = '"Barlow", "Roboto", "Helvetica", Arial, sans-serif';
